import { IBreadcrumbItem } from "@nuorder/components";
import { formatMessage } from "lib/globalize-util";
import { IFolderSelection } from "../containers/space-manager/components/folder-selection/folder-navigation";
import { SpaceView } from "../hooks/utils";
import { MAX_LINEAGE_NODE, SHARED_WITH_ME_ROOT_ITEM_ID } from "./constants";

export const getDriveParams = (spaceView: SpaceView, merchantName?: string): { name: string; icon: string } => {
    switch (spaceView) {
        case SpaceView.MerchantDrive:
            return { name: formatMessage("|Merchant| Drive", { merchant: merchantName }), icon: "merchant18" };
        case SpaceView.MyDrive:
            return { name: formatMessage("My Drive"), icon: "myDrive18" };
        case SpaceView.SharedWithMe:
            return { name: formatMessage("Shared"), icon: "user18" };
        case SpaceView.Starred:
            return { name: formatMessage("Starred"), icon: "star18" };
        default:
            return {} as any;
    }
};

export const buildRootDrive = (
    space: nuorder.folder.v1.Space,
    spaceView: SpaceView,
    merchantName?: string
): IFolderSelection => {
    const id = spaceView === SpaceView.SharedWithMe ? SHARED_WITH_ME_ROOT_ITEM_ID : space?.root_item_id;
    const { name, icon } = getDriveParams(spaceView, merchantName);
    return {
        id,
        spaceView,
        name,
        icon,
        isDrive: true,
        capabilities: space?.capabilities,
    };
};

export const buildBreadcrumb = (
    items: IBreadcrumbItem[],
    newNodes?: Partial<nuorder.folder.v1.Item>[],
    onItemClick?: (ev: React.MouseEvent<HTMLElement>, item: IBreadcrumbItem) => void
): IBreadcrumbItem[] => {
    const nodes = [...items];
    const nodeSize = nodes.length + (newNodes?.length || 0);
    return nodes
        .concat(
            ...(newNodes || []).map((it) => ({
                text: it.name,
                key: it.id,
            }))
        )
        .map((node, index) => {
            const isCurrentItem = index === nodeSize - 1;
            const onClick = isCurrentItem || node.key === MAX_LINEAGE_NODE ? null : onItemClick || node.onClick;
            return {
                ...node,
                isCurrentItem,
                onClick,
            };
        });
};

export const shouldCollectUnkownLineageNodes = (items: IBreadcrumbItem[]) =>
    items.some((item) => item.key === MAX_LINEAGE_NODE);

export const getUnkownLineageNodeIndex = (items: IBreadcrumbItem[]) =>
    items.findIndex((it) => it.key === MAX_LINEAGE_NODE);
